// extracted by mini-css-extract-plugin
export default {"video-container":"edit-telestration_video-container__-NvVr","modal":"edit-telestration_modal__3oCcV"};